// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-e0ba7c1e]{position:relative;z-index:0;width:100%;height:100%}.overlay[data-v-e0ba7c1e],.tracking-layer[data-v-e0ba7c1e]{position:absolute;width:100%;height:100%;top:0;left:0}.camera[data-v-e0ba7c1e],.pause-frame[data-v-e0ba7c1e]{display:block;-o-object-fit:cover;object-fit:cover;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
